import React from 'react';
import styled from 'styled-components';
import StyleConfig from 'src/constants/StyleConfig';

interface Props {
  text: string;
  color?: 'primary' | 'black';
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

export const Heading = ({ ...props }: Props) => {
  const cr = props.color ? props.color : 'black';
  const tg = props.tag ? props.tag : 'p';
  return (
    <Styled color={cr}>
      <span></span>
      {React.createElement(tg, {}, props.text)}
    </Styled>
  );
};

const Styled = styled.div<{ color: 'primary' | 'black' }>`
  display: flex;
  margin-bottom: ${StyleConfig.HELPER.M16};
  > span {
    display: block;
    width: 4px;
    background-color: ${({ color }) => {
      return color === 'primary' ? StyleConfig.COLOR.PRIMARY : StyleConfig.COLOR.TEXT_COLOR;
    }};
    margin-right: ${StyleConfig.HELPER.M8};
  }
  > * {
    font-size: 18px;
    line-height: ${24 / 18};
    font-weight: bold;
    color: ${({ color }) => {
      return color === 'primary' ? StyleConfig.COLOR.PRIMARY : StyleConfig.COLOR.TEXT_COLOR;
    }};
  }
`;
export default Heading;
